<script>
  import DadosCadastrais from './compartilhado/FormDadosCadastrais.vue';
  import solicitacaoBolsaAtividadeServico from '../servico';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  
  export default {
    components: {  DadosCadastrais, AdicionarArquivos },
    data() {
      return {
        atividade: this.camposAtividade(),
        carregando: false,
        configuracao: this.$storage.configuracao(),
      }
    },
    mounted() {
      this.$root.tituloDaPagina = 'Solicitação de ' + this.configuracao.nomeModuloSolContratos + '  - Atividades Liberação';
      this.$root.botaoAcaoMostrar = false;

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';
    },
    methods: {
      validarValorAtividadeContratoVariavel(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (!this.configuracao.valorAtividadeContratoVariavel) return true;

        const valorMaximo = this.$options.filters.formatarNumero(this.atividade.valorMaximo, true);
        const valor = this.$options.filters.formatarNumero(this.atividade.valorLiberado, true);
        var msgErro = "";

        if (valor > valorMaximo) {
          msgErro = "Valor deve ser menor ou igual ao valor atividade";
        }

        if (msgErro) {
          this.$swal(
            '',
            msgErro,
            'info'
          );

          throw new Error("validacao");
          return false;
        }
        else return valido;
      },
      salvar() {
        $('#salvar').button('loading');
        
        this.$refs.dadosCadastrais
          .validar()
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
              throw new Error("validacao");
              exit;
            }

            return valido;
          })
          .then(this.validarValorAtividadeContratoVariavel)
          .then(this.enviar)
          .then(retorno => {
            this.$swal("", "Atividade liberada com sucesso", "success");

            this.$router.push({ name: 'solicitacao-bolsa-atividades' });
          })
          .catch(erro => {
            $('#salvar').button('reset');
            this.$mensagemErro(erro, 'Erro ao liberar a atividade');
          });
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");

        const copiaAtividade = JSON.parse(JSON.stringify(this.atividade));

        return solicitacaoBolsaAtividadeServico.adicionar(copiaAtividade, this.$refs.adicionarArquivos.arquivos);
      },
      mostrarInstrucoes() {
        if (!this.configuracao.solBolsaAtividade) return;

        this.$swal({
          title: 'Instruções da atividade',
          html: this.configuracao.solBolsaAtividade.replace(/\r\n/g, '<br>'),
          type: 'info',
          confirmButtonText: 'Ok, entendi!',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      },
      camposAtividade() {
        return {
          dataEntrega: '',
          dataEntrada: '',
          valorALiberar: '',
          valorMaximo: '',
          valorLiberador: '',
          analise: '',
          idContratoAnaliseTecnica: '',
          idContrato: '',
          contrato: {
            tipoContrato: 0,
          }
        };
      },
      carregar(id) {
        this.carregando = true;

        let atividade = null;

        solicitacaoBolsaAtividadeServico
          .obterPorId(id)
          .then(dados => {
            atividade = dados;
            this.atividade = atividade;
            this.atividade.valorMaximo = this.atividade.valorALiberar;
            this.atividade.valorLiberado = this.atividade.valorALiberar;
          })
          .then(() => {
            this.carregando = false;
            this.$refs.dadosCadastrais.habilitarRPA();
          });
      },
    },
    created() {
      this.carregar(this.$route.params.idCript);
      this.mostrarInstrucoes();
    },
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <form>
      <div class="row">
        <div class="col-xs-12">
          <div class="ibox float-e-margins" v-if="carregando">
            <div class="ibox-content">
              <p class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>
            </div>
          </div>

          <div class="tabs-container" v-show="!carregando" id="tabs">
            <ul class="nav nav-tabs">
              <li class="active">
                <a data-toggle="tab"
                   href="#tab-dados-atividade">
                  Dados da atividade
                </a>
              </li>
              <li v-if="true">
                <a data-toggle="tab"
                   href="#tab-adicionar-arquivos">
                  Adicionar arquivos
                </a>
              </li>
            </ul>
            <div class="tab-content">

              <div id="tab-dados-atividade" class="tab-pane active">
                <div class="panel-body">
                  <dados-cadastrais ref="dadosCadastrais"
                                     :atividade.sync="atividade">
                  </dados-cadastrais>
                </div>
              </div>
              <div id="tab-adicionar-arquivos" class="tab-pane">
                <div class="panel-body">
                  <adicionar-arquivos ref="adicionarArquivos">
                  </adicionar-arquivos>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <router-link class="btn btn-default" :to="{ name: 'solicitacao-bolsa-atividades' }" active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>

            <button id="salvar"
                    type="button"
                    class="btn btn-primary"
                    @click="salvar"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i>
              Salvar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-bolsa-atividades/componentes/SolicitacaoBolsaAtividadesForm.vue